import {Paper} from "@mui/material";
import {styled} from "@mui/system";

const DashboardPaper = styled(Paper)(({theme}) => ({
    border: "1px solid " + theme.palette.divider,
    borderRadius: 8,
    overflow: "hidden"
}));

export default DashboardPaper;
